import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Layout from "../../components/sidebarPro";
import ReadStories from "../../components/stories/read/ReadStories";
import Head from "next/head";
import Footer from "../../components/footer/Footer";

var Index = function Index() {
  return /*#__PURE__*/_jsxs(Layout, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: "WoW Stories - wow kanoon"
      }), /*#__PURE__*/_jsx("link", {
        rel: "icon",
        href: "/images/logos/favicon.png"
      })]
    }), /*#__PURE__*/_jsx(ReadStories, {}), /*#__PURE__*/_jsx(Footer, {
      hasBackToTop: true
    })]
  });
};

export var __N_SSG = true;
export default Index;